export default __webpack_public_path__ + "static/src/assets/images/icons/light/quote_icon_close.png";